import * as React from 'react'

const Envelope = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-hidden='false'
    aria-labelledby='envelope-title'
    fill='none'
    height='18'
    role='img'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    stroke='currentColor'
    viewBox='0 0 24 24'
    width='18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title id='envelope-title'>Envelope icon</title>
    <rect width='20' height='16' x='2' y='4' rx='2' />
    <path d='m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7' />
  </svg>
)

export default Envelope



// WEBPACK FOOTER //
// ./src/components/icons/ui/Envelope.tsx